export function setValidationError(state, hasError) {
  state.validationError = hasError;
  state.lastValidationAttempt = new Date().toISOString();
}

export function setBypassValidation(state, bypass) {
  state.bypassValidation = bypass;
}

export function clearValidationState(state) {
  state.validationError = false;
  state.bypassValidation = false;
}
